(function($) {$(document).ready(function() {

	if ($('.search-results').length === 0) return;

	$('.filter-group__title').on('click', toggleFilterGroup);

	$('.m-search-filters-btn').on('click', openMobileFilters);
	
	$('.search-filters__close').on('click', closeMobileFilters);

	// open first filter group
	$('.filter-group')
		.eq(0)
		.addClass('open')
		.find('.filter-group__filters')
		.show();

	function toggleFilterGroup(event) {
		const $this = $(this);
		$this.closest('.filter-group').toggleClass('open');
		$this.siblings('.filter-group__filters').slideToggle();
	}

	function openMobileFilters(event) {
		$('.search-filters').addClass('open');
	}

	function closeMobileFilters(event) {
		$('.search-filters').removeClass('open');
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);